export default __webpack_public_path__ + "static/media/havilla_logo.4a887036.svg";